import { render, staticRenderFns } from "./ProtocoloVerdeGraosStatusOk.vue?vue&type=template&id=40f74d10&lang=pug"
import script from "./ProtocoloVerdeGraosStatusOk.vue?vue&type=script&lang=js"
export * from "./ProtocoloVerdeGraosStatusOk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports